// src/pages/WritePost/CreatePostPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import BlogLayout from "../../components/BlogLayout";
import PostForm from "../../components/PostForm";
import { useAuth } from "../../hooks/useBlogAPI";
import api from "../../api/blogAPI";
import "./CreatePostPage.css";

const CreatePostPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSubmit = async (values) => {
    try {
      const postData = {
        ...values,
        author: user.username,
        categoryId: 1,
        views: 0,
        comments: [],
      };

      await api.createPost(postData);
      message.success("文章创建成功！");
      navigate("/archive");
    } catch (error) {
      message.error("创建失败: " + error.message);
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  const handleCreatePost = () => {
    navigate("/posts/create");
  };

  return (
    <BlogLayout onCreatePost={handleCreatePost}>
      <div className="container">
        <PostForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          mode="create"
        />
      </div>
    </BlogLayout>
  );
};

export default CreatePostPage;
